import { graphql } from "msw";

import {
  BannerByPageQuery,
  BannerByPageQueryVariables,
} from "@common-vendors/generated/graphql";

import { mockBanner } from "./PageBanner.mock";

export const handler = graphql.query<
  BannerByPageQuery,
  BannerByPageQueryVariables
>("BannerByPage", (_request, response, context) => {
  return response(
    context.data({
      __typename: "Query" as const,
      ...mockBanner,
    })
  );
});
